import script from "./MySurvey.vue?vue&type=script&setup=true&lang=js"
export * from "./MySurvey.vue?vue&type=script&setup=true&lang=js"

import "./MySurvey.vue?vue&type=style&index=0&id=06cea0d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06cea0d6"]])

export default __exports__